/**
 * RecentlyViewedContext — localStorage-backed list of last N product IDs
 * the user has opened. Used on PDP + Home.
 */
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const LS_KEY = "bb_recently_viewed_v1";
const MAX = 20;
const Ctx = createContext(null);

const read = () => { try { return JSON.parse(localStorage.getItem(LS_KEY) || "[]"); } catch { return []; } };
const write = (arr) => { try { localStorage.setItem(LS_KEY, JSON.stringify(arr)); } catch { /* noop */ } };

export function RecentlyViewedProvider({ children }) {
  const [ids, setIds] = useState(read);

  useEffect(() => {
    const onStorage = (e) => { if (e.key === LS_KEY) setIds(read()); };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const track = useCallback((id) => {
    if (!id) return;
    setIds((prev) => {
      const next = [id, ...prev.filter((x) => x !== id)].slice(0, MAX);
      write(next);
      return next;
    });
  }, []);

  const value = useMemo(() => ({ ids, track }), [ids, track]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useRecentlyViewed = () => useContext(Ctx) || { ids: [], track: () => {} };
